import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../data/client";

const URL_ = "/api/auth/next/viewing-as";
export type ViewingAsMode = { active: boolean; look_only?: boolean; changes_allowed?: boolean; minutes_left?: number | null; warn_at_minutes?: number; extend_minutes?: number };

/** K4.2/K4.3: the live viewing-as session's mode and time left. Polled while staff view as someone; nothing is asked otherwise. */
export const useViewingAsMode = (enabled: boolean) =>
  useQuery({
    queryKey: ["viewing-as-mode"],
    queryFn: async () => (await api.get<{ data: ViewingAsMode }>(URL_)).data,
    enabled,
    refetchInterval: 30_000,
    retry: false,
  });

const useSession = (path: "allow-changes" | "extend") => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post<{ data: ViewingAsMode }>(`${URL_}/${path}`)).data,
    onSuccess: (data) => client.setQueryData(["viewing-as-mode"], data),
  });
};
export const useAllowChanges = () => useSession("allow-changes");
export const useExtendViewing = () => useSession("extend");
